import { useEffect, useState } from "react";
import UserOrders from "../../../../features/userDashboard/orders/UserOrders";
import OrderDetails from "./OrderDetails";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useOrder from "../../../../features/userDashboard/orders/useOrders";
import Dashboard from "../../Dashboard";
import useOrders from "../../../../features/userDashboard/orders/useOrders";

const Order = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");
  const orderId = params.get("orderId");
  const [activeTab, setActiveTab] = useState(
    tabParam === "details" ? "details" : "list"
  );
  const [order, setOrder] = useState(null);

  const { userOrders, userOrdersError, isGettingUserOrders } = useOrders();

  // Fetch order if orderId is present and on details tab
  // const {
  //   orderIdData: fetchedOrder,
  //   isGettingOrderById: isOrderLoading,
  //   isErrorGettingOrderById: orderError,
  // } = useOrder(activeTab === "details" && orderId ? orderId : null);
  // console.log("fetchedOrder: ", fetchedOrder);
  useEffect(() => {
    if (tabParam === "details") setActiveTab("details");
    else setActiveTab("list");
  }, [tabParam]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  return (
    <Dashboard title="My Orders" description="View your order history">
      <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
        <button
          onClick={() => setActiveTab("list")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "list"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          List Orders
        </button>
        <button
          onClick={() => setActiveTab("details")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "details"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Order Details
        </button>
      </div>
      {activeTab === "list" && (
        <UserOrders onSetOrder={setOrder} onSetActiveTab={setActiveTab} />
      )}
      {activeTab === "details" &&
        (orderId ? (
          isGettingUserOrders ? (
            <div className="text-center py-10 text-gray-500">
              Loading order details...
            </div>
          ) : userOrdersError ? (
            <div className="text-center py-10 text-red-500">
              Failed to load order details.
            </div>
          ) : (
            <OrderDetails
              order={userOrders.find((order) => order._id === orderId)}
            />
          )
        ) : (
          <div className="text-center py-10 text-gray-500">
            No order selected. Please select an order from the list.
          </div>
        ))}

      {!orderId && activeTab === "details" && <OrderDetails order={order} />}
    </Dashboard>
  );
};
export default Order;
